// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2isXz","file":"styles_file__3vPwi"};